import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useState } from 'react';
const ToastContext = createContext(undefined);
let nextId = 0;
const typeStyles = {
    success: 'bg-success',
    error: 'bg-danger',
    warning: 'bg-warning',
    info: 'bg-info',
};
const typeIcons = {
    success: '\u2713',
    error: '\u2717',
    warning: '\u26A0',
    info: '\u2139',
};
export function ToastProvider({ children }) {
    const [toasts, setToasts] = useState([]);
    const removeToast = useCallback((id) => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
    }, []);
    const showToast = useCallback((message, type = 'info', durationMs = 5000) => {
        const id = nextId++;
        setToasts((prev) => {
            const updated = [...prev, { id, message, type }];
            // Keep max 3 visible
            return updated.length > 3 ? updated.slice(-3) : updated;
        });
        setTimeout(() => removeToast(id), durationMs);
    }, [removeToast]);
    return (_jsxs(ToastContext.Provider, { value: { showToast }, children: [children, _jsx("div", { className: "fixed bottom-4 right-4 z-50 flex flex-col gap-2 max-w-sm", children: toasts.map((toast) => (_jsxs("div", { className: `${typeStyles[toast.type]} text-white px-4 py-3 rounded-xl shadow-lg flex items-center gap-3 animate-slide-in`, role: "alert", children: [_jsx("span", { className: "text-lg font-bold flex-shrink-0", children: typeIcons[toast.type] }), _jsx("p", { className: "text-sm flex-1", children: toast.message }), _jsx("button", { onClick: () => removeToast(toast.id), className: "flex-shrink-0 text-white/80 hover:text-white", "aria-label": "Dismiss", children: "\u00D7" })] }, toast.id))) }), _jsx("style", { children: `
        @keyframes slide-in {
          from { transform: translateX(100%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
        .animate-slide-in { animation: slide-in 0.3s ease-out; }
      ` })] }));
}
export function useToast() {
    const ctx = useContext(ToastContext);
    if (!ctx)
        throw new Error('useToast must be used within a ToastProvider');
    return ctx;
}
//# sourceMappingURL=ToastContext.js.map